// extracted by mini-css-extract-plugin
export default {"container":"dFEj63l4korbwP5M8KC1","icon":"HMT37Du2_BEIwnOWfNyR","header":"V1fo6AfxxLKVOyv9Iwya","content":"zF2zW1G9SD9rM1afoQJm","close":"gIqGZmWk7aM0FabO51LE"};